import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import TradingCoreFacet from '../abis/TradingCoreFacet';
import { getContractAddress } from '../constants';

export const getTradingCoreFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: TradingCoreFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
